module.exports = __webpack_public_path__ + "web/img/flv.8d929590.png";